import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'components/core/Link';
import { ReviewExcerptPopover } from 'components/review/ReviewExcerpt';

export default function FacilityRatingLabelWithReview({
	reviewsUrl,
	numberOfRatings,
	onMouseOver,
	onMouseOut,
	review,
	reviewShowing,
	reviewTitle,
}) {
	return (
		<span className="review-count">
			Based on{' '}
			<Link
				href={reviewsUrl}
				secondary
				onMouseOver={onMouseOver}
				onFocus={onMouseOver}
				onMouseOut={onMouseOut}
				onBlur={onMouseOut}
				productClick
			>
				<span itemProp="reviewCount">{numberOfRatings}</span>{' '}
				{numberOfRatings === 1 ? 'review' : 'reviews'}
			</Link>
			{!!review && (
				<ReviewExcerptPopover
					showing={reviewShowing}
					title={reviewTitle}
					review={review}
					position="bottom"
				/>
			)}
		</span>
	);
}

FacilityRatingLabelWithReview.propTypes = {
	reviewShowing: PropTypes.bool,
	review: PropTypes.object,
	reviewsUrl: PropTypes.string,
	reviewTitle: PropTypes.string,
	numberOfRatings: PropTypes.number,
	onMouseOver: PropTypes.func.isRequired,
	onMouseOut: PropTypes.func.isRequired,
};
